import { TOAST_ERROR_TIMEOUT } from '@app/app.constants';
import { ID } from '@app/utils/common';
import { Observable, Subject } from 'rxjs';

/**
 * Only used by the ErrorToastService.
 */
export class Toast {
  private isHovering = false;
  private subject: Subject<void>;
  private timeout = TOAST_ERROR_TIMEOUT;
  private timeoutId: number | null;

  private _id = ID();

  get id(): string {
    return this._id;
  }

  private _ref: HTMLElement;

  get ref(): HTMLElement {
    return this._ref;
  }

  constructor(
    private title: string,
    private message: string,
    private destroyed: () => void
  ) {
    this.createToast();
  }

  hide(force: boolean = false): void {
    if (this.isHovering === false || force) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }

      this.destroyToast();
    }
  }

  show(): Observable<void> {
    this.subject = new Subject<void>();

    this.timeoutId = window.setTimeout(() => {
      this.hide();
      this.timeoutId = null;
    }, this.timeout);

    return this.subject;
  }

  private createToast(): void {
    let header: string;
    let body: string;

    if (this.message != null) {
      body = `<div class="toast-body">${this.message}</div>`;
      header = `<div class="toast-header"><span class="me-auto">${this.title}</span></div>`;
    } else {
      body = `<div class="toast-body">${this.title}</div>`;
      header = '';
    }

    const toast: string = `<div class="toast portal-toast bg-danger text-light fade show">${header}${body}</div>`;

    this._ref = $(toast).on('click mouseleave mouseenter', (event) => {
      if (event.type === 'click') {
        this.hide(true);
      } else if (event.type === 'mouseenter') {
        this.isHovering = true;
      } else if (event.type === 'mouseleave') {
        this.isHovering = false;

        if (this.timeoutId == null) {
          this.hide();
        }
      }
    })[0];
  }

  private destroyToast<T>() {
    this._ref.remove();
    this.subject.next();
    this.subject.complete();

    this.destroyed();
  }
}
